const THANKS_MESSAGE_CONSTANTS = {
    ERROR: "We're sorry, we couldn't validate your number. Please try again.",
    WE_ARE_SORRY : "We're Sorry",
    OTP_LIMIT_EXCEEDED : "OTP Limit Exceeded",
    SUBMITTED : "Submitted",
    COMMAN_ERROR_TITLE:"We're sorry!",
    COMMAN_ERROR_MESSAGE:"An unexpected error has occurred. Our technical staff has been automatically notified and will be looking into this with utmost urgency."
};

export const PLAN_CONFIGURATION_MSG = {
    CHANGE_CONFIGURATION : "Your configuration changes in previously selected plan will be lost, are you sure to continue?"
}

export default THANKS_MESSAGE_CONSTANTS;